/* UI */
export const CardContextMenuUI = 'card-context-menu'
export const CellEditorUI = 'cell-editor'
export const SidePanelUI = 'side-panel'
export const RowDraggerMenuUI = 'row-dragger-menu'
export const TitleFieldUI = 'title field'
